import React from 'react'
import RMAFormPart from '../../react4xp/components/FormPages/RMAForm'
import { country_list } from '/lib/modules/util/constants'

function RMAForm({ breadcrumbs, title, intro, emailServiceUrl, privacyPolicyCheckboxRichText, recaptchaSiteKey, recaptchaValidationUrl, validationSummary}) {
	return (
		<RMAFormPart
			siteKey={recaptchaSiteKey}
			validationRecaptchaUrl={recaptchaValidationUrl}
			topInfos={{
				title: title,
				intro: intro
			}}
			form={{
				endpoint: emailServiceUrl,
				onSuccess: () => console.log('Sending email...'),
				onError: () => console.error('Error sending email')
			}}
			steps={{
				step1: {
					title: 'Choose request type',
					options: [
						{
							value: 'Request for repair'
						},
						{
							value: 'Request for replacement'
						},
						{
							value: 'Request for return',
						}
					],
					errorMessage: 'Please choose one request type.'
				},
				step2: {
					title: 'Fill in your details',
					inputs: [
						{
							type: 'text',
							id: 'company-name',
							name: 'Company name',
							label: 'Company name',
							required: true,
							errorMessages: {
								required: 'This field is required.'
							}
						},
						{
							type: 'text',
							id: 'contact-person-name',
							name: 'Contact person name',
							label: 'Contact person name',
							required: true,
							errorMessages: {
								required: 'This field is required.'
							}
						},
						{
							type: 'email',
							id: 'email',
							name: 'Email',
							label: 'Email',
							required: true,
							errorMessages: {
								required: 'This field is required.',
								invalidEmail: 'Invalid email format.'
							}
						},
						{
							type: 'tel',
							id: 'phone-number',
							name: 'Phone number',
							label: 'Phone number',
							required: true,
							errorMessages: {
								required: 'This field is required.'
							}
						}
					]
				},
				step3: {
					title: 'Equipment details',
					equipment: {
						title: 'Equipment',
						inputs: [
							{
								name: 'Part number',
								label: 'Part number',
							},
							{
								name: 'Product name',
								label: 'Product name',
							},
							{
								name: 'Serial / batch number',
								label: 'Serial / batch number',
							},
							{
								name: 'Fault description / Reason for return',
								label: 'Fault description / Reason for return'
							}
						],
						deleteButtonText: 'Delete equipment',
						addButtonText: 'Add equipment'
					},
					additionalInformation: {
						id: 'additional-information',
						name: 'Additional information',
						label: 'Additional information',
						placeholder: 'Write your message here...',
						helperText: 'If you have any of the details below please include it here. <br />Order number / Project ID / Case ID Claim no / Hull no / PO no for repair / Project name / Vessel name / End-user',
						required: true,
						errorMessages: {
							required: 'This field is required.'
						}
					}
				},
				step4: {
					title: 'Billing address',
					inputs: [
						{
							type: 'text',
							id: 'billing-company-name',
							name: 'Billing company name',
							label: 'Company name',
							required: true,
							errorMessages: {
								required: 'This field is required.'
							}
						},
						{
							type: 'text',
							id: 'billing-address-1',
							name: 'Billing address 1',
							label: 'Address 1',
							required: true,
							errorMessages: {
								required: 'This field is required.'
							}
						},
						{
							type: 'text',
							id: 'billing-address-2',
							name: 'Billing address 2',
							label: 'Address 2'
						},
						{
							type: 'text',
							id: 'billing-address-3',
							name: 'Billing address 3',
							label: 'Address 3'
						},
						{
							type: 'text',
							id: 'billing-postal-code',
							name: 'Billing postal code',
							label: 'Postal code',
							required: true,
							errorMessages: {
								required: 'This field is required.'
							}
						}
					],
					country: {
						id: 'billing-country',
						name: 'Billing country',
						label: 'Country',
						defaultValue: 'Choose country',
						options: country_list,
						required: true,
						errorMessages: {
							required: 'This field is required.'
						}
					},
					billingAddress: {
						checkbox: {
							id: 'same-billing-address',
							name: 'Billing delivery information',
							label: 'Delivery information',
							text: 'Use billing address as delivery address',
						},
						title: 'Delivery Address',
						inputs: [
							{
								type: 'text',
								id: 'delivery-company-name',
								name: 'Delivery company name',
								label: 'Company name',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							},
							{
								type: 'text',
								id: 'delivery-address-1',
								name: 'Delivery address 1',
								label: 'Address 1',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							},
							{
								type: 'text',
								id: 'delivery-address-2',
								name: 'Delivery address 2',
								label: 'Address 2'
							},
							{
								type: 'text',
								id: 'delivery-address-3',
								name: 'Delivery address 3',
								label: 'Address 3'
							},
							{
								type: 'text',
								id: 'delivery-postal-code',
								name: 'Delivery postal code',
								label: 'Postal code',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						],
						country: {
							id: 'delivery-country',
							name: 'Delivery country',
							label: 'Country',
							defaultValue: 'Choose country',
							options: country_list,
							required: true,
							errorMessages: {
								required: 'This field is required.'
							}
						}
					},
					preferredSolution: {
						id: 'preferred-solution',
						name: 'Preferred Solution',
						label: 'Preferred Solution',
						defaultValue: 'Choose preferred solution',
						options: [
							{ label: 'Repair', value: 'Repair' },
							{ label: 'Replacement', value: 'Replacement' },
							{ label: 'Credit', value: 'Credit' }
						],
						helperText: 'To ensure a smooth customs clearance, please provide the proforma invoice within your shipment documentation.'
					}
				}
			}}
			privacyCheckbox={{
				name: 'terms',
				required: true,
				errorMessages: {
					required: 'This field is required.'
				},
				text: privacyPolicyCheckboxRichText
			}}
			submit={{
				validationMessage: validationSummary,
				label: 'Submit',
				successMessage: 'Your message has been submitted successfully.'
			}}
		/>
	)
}

export default RMAForm